import api from '..'

export interface LinkExternalCourseResponse {
  name: string
  description: string
  id: number
  hours?: number
}

const LinkExternalCourse = (url: string) => {
  return api.post<LinkExternalCourseResponse>('administration/coursera/data', {
    integration_course_link: url,
  })
}

export default LinkExternalCourse
